let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b6Wqe")).then(() => parcelRequire('bEwr2'));